import React from 'react';
import c from 'classnames';

import { CallToAction } from '@uncinc/uncinc-react-kitchen-sink';
import { CallToActionProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/CallToAction';

import Block from '../Block';

import './style.scss';

const BlockCta: React.FC<CallToActionProps> = (props) => {
  const { className } = props;

  const classNames = c('BlockCta', className);

  return (
    <Block type="primary" className={classNames}>
      <CallToAction {...props} className="BlockCta__inner" />
    </Block>
  );
};

export default BlockCta;
